import { FunctionComponent, useEffect, useState } from "react";
import { SocialAuth } from "../../components/SocialAuth/SocialAuth";
import { useAppDispatch, useAppSelector } from "@store/store";
import { selectClient } from "@store/client/clientReducer";
import { Trans, useTranslation } from "react-i18next";
import { AuthInstructions } from "../../components/AuthInstructions/AuthInstructions";
import { SignInFormEmail } from "../../components/SignInFormEmail/SignInFormEmail";
import { SignInFormSms } from "../../components/SignInFormSms/SignInFormSms";
import { selectAuthView, setAuthFlowAction } from "@store/sessionReducer";
import { FormStatus } from "app/javascript/src/modules/components/formFields/FormStatus";

interface SignInMagicLinkProps {}

const SignInMagicLink: FunctionComponent<SignInMagicLinkProps> = () => {
  const { t } = useTranslation();
  const client = useAppSelector(selectClient);
  const view = useAppSelector(selectAuthView);
  const dispatch = useAppDispatch();
  const [state, setState] = useState<{ status: FormStatus }>({
    status: "idle",
  });

  useEffect(() => {
    dispatch(setAuthFlowAction({ authFlow: "signIn" }));
  }, [dispatch]);

  const disabled = state.status === "fetching" || state.status === "success";

  return (
    <>
      <AuthInstructions />
      {view === "signInEmail" && (
        <SignInFormEmail
          status={state.status}
          setState={setState}
          disabled={disabled}
        />
      )}
      {view === "signInSms" && (
        <SignInFormSms
          status={state.status}
          setState={setState}
          disabled={disabled}
        />
      )}

      <p className="terms">
        <Trans
          i18nKey="authentication.terms"
          components={{
            terms: (
              <a
                key="terms"
                href="https://visitwidget.com/terms/"
                target="_blank"
                rel="noreferrer"
              />
            ),
            privacy: (
              <a
                key="privacyPolicy"
                href={client.privacyPolicyUrl}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </p>

      <div className="continue-container">
        <p>{t("common.or")}</p>
      </div>
      <SocialAuth disabled={disabled} />
    </>
  );
};

export { SignInMagicLink };
